// TODO (Lint): Remove lint rule skip & fix the lint issue
/* eslint-disable max-lines */
import {
  AfterViewInit,
  ChangeDetectorRef,
  Directive,
  ElementRef,
  Input,
  OnChanges,
  Renderer2
} from '@angular/core';

@Directive({
  selector: '[idpAppModalfocus]'
})
export class ModalfocusDirective implements OnChanges, AfterViewInit {
  @Input() modalfocusparent = false;
  @Input() focusOnModal = false;
  @Input() modalcontentloaded = false;
  @Input() modalType = '';

  /**
   * Following vars are of HTMLElement types which could cause
   * issues while compiling this directive in SSR environment
   * hence leaving these as any types.
   */
  focusableElements: HTMLElement[] = [];
  firstFocusableElement: HTMLElement = {} as HTMLElement;
  lastFocusableElement: HTMLElement = {} as HTMLElement;

  constructor(
    public ren: Renderer2,
    public cdf: ChangeDetectorRef,
    public el: ElementRef
  ) {}

  ngOnChanges(): void {
    this.changesHandler();
  }

  changesHandler() {
    // setTimeout added for waiting to update the view and then update focusable item list
    setTimeout(() => {
      this.trapFocusInsideModal();
      this.setFocusOnModalOnContentChange();
    }, 1);
  }

  // when content inside modal gets changed, focus on the modal or any specific element
  setFocusOnModalOnContentChange() {
    const { focusableElements = [], focusOnModal } = this;
    if (focusOnModal && focusableElements[0]) {
      focusableElements[0].focus();
    }
  }

  ngAfterViewInit() {
    this.trapFocusInsideModal();
    this.setFocusOnModalOnContentChange();
  }

  checkTripContent() {
    return (
      this.el.nativeElement &&
      this.el.nativeElement.className === 'trip-extras-content'
    );
  }

  checkSecondaryContent() {
    return (
      this.el.nativeElement &&
      this.el.nativeElement.className === 'idp-dialog focus-trap secondary'
    );
  }

  checkActiveElement() {
    return this.el.nativeElement && this.el.nativeElement.children[0];
  }

  isElementPresent() {
    return this.el.nativeElement ? this.el.nativeElement.children[0] : null;
  }

  getActivemodalElement() {
    return this.checkTripContent()
      ? this.el.nativeElement.children[2]
      : this.checkSecondaryContent()
      ? this.el.nativeElement
      : this.checkActiveElement()
      ? this.el.nativeElement.children[0].children[0]
      : this.isElementPresent();
  }

  trapFocusInsideModal() {
    const activeModalElement = this.getActivemodalElement();
    if (activeModalElement) {
      const tabbableEls = activeModalElement.querySelectorAll(`a[href],
      area[href],
      input:not([disabled]),
      select:not([disabled]),
      textarea:not([disabled]),
      button:not([disabled]),
      [tabindex="0"]`);
      this.modalElementsFocus(tabbableEls, activeModalElement);
      this.focusableElements = Array.prototype.slice.call(
        this.focusableElements
      );
      if (!this.focusOnModal) {
        this.firstFocusableElement = this.focusableElements[0];
        this.focusableElements = activeModalElement.querySelectorAll(
          'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select'
        );
      } else {
        this.firstFocusableElement = this.focusableElements[1];
      }
      this.lastFocusableElement =
        this.focusableElements[this.focusableElements.length - 1];
      const KEYCODE_TAB = 9;
      this.modalTabEvent(KEYCODE_TAB, activeModalElement);
      this.modalcontentloaded = false;
    }
  }

  modalElementsFocus(
    tabbableEls: HTMLElement,
    activeModalElement: HTMLElement
  ) {
    const filter = Array.prototype.filter;
    this.focusableElements = filter.call(tabbableEls, (el: Element) => {
      let elCopy = el;
      while (elCopy !== activeModalElement) {
        const displayVal = window
          .getComputedStyle(elCopy, null)
          .getPropertyValue('display');
        const visibilityVal = window
          .getComputedStyle(elCopy, null)
          .getPropertyValue('visibility');
        if (displayVal !== 'none' && visibilityVal !== 'hidden') {
          elCopy = elCopy.parentNode as Element;
        } else {
          return false;
        }
      }
      return true;
    });
  }

  modalTabEvent(KEYCODE_TAB: number, activeModalElement: HTMLElement) {
    activeModalElement.addEventListener('keydown', (e: KeyboardEvent) => {
      let insideModal = false;
      if (this.checkModalType()) {
        this.focusableElements.forEach((key) => {
          if (key === document.activeElement) {
            insideModal = true;
          }
        });
      } else {
        insideModal = true; // override for ecredit modal
      }
      if (this.isTabSelected(e, KEYCODE_TAB)) {
        if (e.shiftKey) {
          this.checkFirstFocusElement(insideModal, e);
        } else {
          this.checkLastFocusElement(insideModal, e);
        }
      }
    });
  }

  checkModalType() {
    return this.modalType !== 'ecreditModal' && this.modalType !== 'info';
  }

  isTabSelected(e: KeyboardEvent, KEYCODE_TAB: number) {
    return e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
  }

  checkFirstFocusElement(insideModal: boolean, e: KeyboardEvent) {
    if (document.activeElement === this.firstFocusableElement || !insideModal) {
      this.lastFocusableElement.focus();
      e.preventDefault();
    }
  }

  checkLastFocusElement(insideModal: boolean, e: KeyboardEvent) {
    if (document.activeElement === this.lastFocusableElement || !insideModal) {
      this.firstFocusableElement.focus();
      e.preventDefault();
    }
  }
}
